import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../Button/Button';
import Styles from '../Styles.module.scss';

const SubmitButton = ({ onSubmit: handleSubmit, loading, children, type, size, className }) => {
  return (
    <Button
      style={{ marginTop: 'auto' }}
      type={type}
      size={size}
      disabled={loading}
      onClick={handleSubmit}
      className={className}>
      {(loading && (
        <div className={Styles.loader}>
          <div className={Styles.dot} />
          <div className={Styles.dot} />
          <div className={Styles.dot} />
        </div>
      )) ||
        children}
    </Button>
  );
};

SubmitButton.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  onSubmit: PropTypes.func,
  type: PropTypes.string,
  size: PropTypes.string,
};

SubmitButton.defaultProps = {
  type: Button.Type.BLUE,
  size: Button.Size.FULLWIDTH_LARGE,
};

export default SubmitButton;
